export default {
  methods: {
    okDialog(msg, opts = {}) {
      let config = {
        okVariant: "primary",
        okTitle: "OK"
      };
      return this.$bvModal.msgBoxOk(msg, config);
    },
    confirmDialog(msg, opts = {}) {
      let config = {
        okVariant: "primary",
        okTitle: "Tak",
        cancelTitle: "Nie",
        cancelVariant: "outline-primary",
        ...opts
      };
      return this.$bvModal.msgBoxConfirm(msg, config);
    },
    deleteDialog(msg, opts = {}) {
      let config = {
        okVariant: "danger",
        okTitle: "Tak",
        cancelTitle: "Nie",
        cancelVariant: "outline-danger",
        ...opts
      };
      return this.confirmDialog(msg, config);
    }
  }
};
